import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface FilePreviewDialogData {
    fileUrl: string;
    fileName: string;
    contentType: string;
}

@Component({
    selector: 'app-image-preview-dialog',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './image-preview-dialog.component.html',
    styleUrls: ['./image-preview-dialog.component.less']
})
export class ImagePreviewDialogComponent {
    safeUrl: SafeResourceUrl;
    isImage: boolean;
    isPdf: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FilePreviewDialogData,
        private readonly dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
        private readonly sanitizer: DomSanitizer
    ) {
        this.isImage = data.contentType.startsWith('image/');
        this.isPdf = data.contentType === 'application/pdf';
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.fileUrl);
    }

    close(): void {
        this.dialogRef.close();
    }

    download(): void {
        const link = document.createElement('a');
        link.href = this.data.fileUrl;
        link.download = this.data.fileName;
        link.click();
    }
}
